import { useCallback, useState } from 'react';
import { readStored, writeStored } from './storage';

const KEY = 'khaddi.client.favourites';

const load = (): string[] => {
  const stored = readStored(KEY);
  return Array.isArray(stored) ? stored.filter((id): id is string => typeof id === 'string') : [];
};

/** Favourite drinks are a per-device convenience; the API has no favourites yet. */
export const useFavourite = (productId: string) => {
  const [ids, setIds] = useState<string[]>(load);
  const favourite = ids.includes(productId);
  const toggle = useCallback(() => {
    const next = favourite ? ids.filter((id) => id !== productId) : [...ids, productId];
    setIds(next);
    writeStored(KEY, next);
  }, [favourite, ids, productId]);
  return { favourite, toggle };
};
